export const MILLISECONDS_TO_DELAY_NOTIFICATION_CLOSE = 7000;

export const NOTIFICATION_TYPE_ERROR = 'error';
export const NOTIFICATION_TYPE_SUCCESS = 'success';
